import { HiCheckBadge } from "react-icons/hi2";

export const VerifiedIcon = ({ width, height, color, ...props }) => (
  <HiCheckBadge
    size={width || height || 24}
    color={color || "currentColor"}
    {...props}
  />
);
